<input type="checkbox" [ngModel]="params?.data.isChecked" (ngModelChange)="params.data.isChecked = $event" (change)="refresh(params)">